import { render } from "./CreateDetailAgendaSubKomunitasView.vue?vue&type=template&id=0e674352"
import script from "./CreateDetailAgendaSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./CreateDetailAgendaSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__